import LoadingView from './views/_loading.vue'
import TimeoutView from './views/_timeout.vue'

export default [
  {
    path: '/',
    redirect: { name: 'select' },
  },
  {
    path: '/system/*',
    name: 'select',
    meta: { authRequired: true },
    component: () => lazyLoadView(import('./views/select.vue')),
  },
  {
    // Prevent cross-domain storage issues by hosting auth helpers ourselves:
    // https://firebase.google.com/docs/auth/web/redirect-best-practices#self-host-helper-code
    path: '/__/auth/handler',
    component: () => lazyLoadView(import('./views/authHelperRedirect.vue')),
  },
  {
    // Prevent cross-domain storage issues by hosting auth helpers ourselves:
    // https://firebase.google.com/docs/auth/web/redirect-best-practices#self-host-helper-code
    path: '/__/auth/iframe',
    component: () => lazyLoadView(import('./views/authHelperRedirect.vue')),
  },
  {
    path: '*',
    component: () => lazyLoadView(import('./views/_404.vue')),
    // Allows props to be passed to the 404 page through route
    // params, such as `resource` to define what wasn't found.
    props: true,
  },
]

// Lazy-loads view components, but with better UX. A loading view
// will be used if the component takes a while to load, falling
// back to a timeout view in case the page fails to load. You can
// use this component to lazy-load a route with:
//
// component: () => lazyLoadView(import('@views/my-view'))
//
// NOTE: Components loaded with this strategy DO NOT have access
// to in-component guards, such as beforeRouteEnter,
// beforeRouteUpdate, and beforeRouteLeave. You must either use
// route-level guards instead or lazy-load the component directly:
//
// component: () => import('@views/my-view')
//
function lazyLoadView(AsyncView) {
  const AsyncHandler = () => ({
    component: AsyncView,
    // A component to use while the component is loading.
    loading: LoadingView,
    // Delay before showing the loading component.
    // Default: 200 (milliseconds).
    delay: 400,
    // A fallback component in case the timeout is exceeded
    // when loading the component.
    error: TimeoutView,
    // Time before giving up trying to load the component.
    // Default: Infinity (milliseconds).
    timeout: 10000,
  })

  return Promise.resolve({
    functional: true,
    render(h, { data, children }) {
      // Transparently pass any props or children
      // to the view component.
      return h(AsyncHandler, data, children)
    },
  })
}
